import { message } from 'antd';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { history } from "../../../appRedux/store";
import { getVisitReportAPI } from "../../../services/group-admin-service";
import { SET_VISIT_LOCK } from '../../actions/activityAction';

import {
    VIEW_PARKED_VISIT,
    VIEW_PARKED_VISIT_ERROR,
    VIEW_PARKED_VISIT_START,
    VIEW_PARKED_VISIT_SUCCESS,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
    VIEW_SUBMITTED_TO_TYPIST_VISIT,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_START,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS,

} from "../../actions/groupadmin/reportViewerAction";
import { TICKET_DETAILS_RESET } from '../../actions/ticketing/ticketActions';

const getRoutingLocation = (state) => state.routing.location;

function* viewSubmittedForVerification({ report }) {

    try {
        const { pathname } = yield select(getRoutingLocation);
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_START })
        const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
        if (visitReportResponse.success) {
            yield put({
                type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
                report: {
                    ...visitReportResponse.visitReport
                }
            })
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            history.push({
                pathname: '/groupadmin/report-viewer',
                state: {
                    from: pathname
                }
            });
        } else {
            yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR })
            message.error('Failed to view visit!');
        }
    } catch (error) {
        yield put({ type: VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR, error })
        message.error('Failed to view visit!');
    }
}

function* viewParkedVisit({ report }) {
    try {
        const { pathname } = yield select(getRoutingLocation);
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_PARKED_VISIT_START })
        const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
        if (visitReportResponse.success) {
            yield put({
                type: VIEW_PARKED_VISIT_SUCCESS,
                report: {
                    ...visitReportResponse.visitReport
                }
            })
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            history.push({
                pathname: '/groupadmin/report-viewer',
                state: {
                    from: pathname
                }
            });
        } else {
            yield put({ type: VIEW_PARKED_VISIT_ERROR })
            message.error('Failed to view visit!');
        }
    } catch (error) {
        yield put({ type: VIEW_PARKED_VISIT_ERROR, error })
        message.error('Failed to view visit!');
    }
}

function* viewSubmittedToTypistVisit({ report }) {
    try {
        const { pathname } = yield select(getRoutingLocation);
        yield put({
            type: TICKET_DETAILS_RESET,
        })
        yield put({ type: VIEW_SUBMITTED_TO_TYPIST_VISIT_START })
        const visitReportResponse = yield getVisitReportAPI(report.risId, report.reportId, report.visitNo);
        if (visitReportResponse.success) {
            yield put({
                type: VIEW_SUBMITTED_TO_TYPIST_VISIT_SUCCESS,
                report: {
                    ...visitReportResponse.visitReport
                }
            })
            yield put({
                type: SET_VISIT_LOCK,
                selectedVisit: {
                    isVisitLocked: false,
                    reportId: null
                }
            })
            history.push({
                pathname: '/groupadmin/report-viewer',
                state: {
                    from: pathname
                }
            });
        } else {
            yield put({ type: VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR })
            message.error('Failed to view visit!');
        }
    } catch (error) {
        yield put({ type: VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR, error })
        message.error('Failed to view visit!');
    }
}


function* reportViewerWatcher() {
    yield takeLatest(VIEW_SUBMITTED_FOR_VERIFICATION_VISIT, viewSubmittedForVerification)
    yield takeLatest(VIEW_PARKED_VISIT, viewParkedVisit)
    yield takeLatest(VIEW_SUBMITTED_TO_TYPIST_VISIT, viewSubmittedToTypistVisit)
}


export default function* rootSaga() {
    yield all([
        reportViewerWatcher(),
    ]);
}